import { render, staticRenderFns } from "./settings-organization-help-widget.vue?vue&type=template&id=030d3661&scoped=true&"
import script from "./settings-organization-help-widget.vue?vue&type=script&lang=js&"
export * from "./settings-organization-help-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d3661",
  null
  
)

export default component.exports